export default {
  baseSeed: 42,
  fontSize: 67,
  fontStyle: 'Arial',
  language: 'en',
  baseScreenWidth: 1920,
  baseScreenHeight: 1080,
  speedChanger: 5,
  tasksTabletButtons: {
    backgroundColor: 0x2392ba,
    pressedBackgroundColor: 0x45b3e0,
    Width: 150,
    Height: 50,
    borderRadius: 24,
    fontSize: '24px',
    fontColor: '#fff',
    origin: 0.5,
    alpha: 1,
    fontStyle: 'Open Sans',
  },
  tascScene: {
    easyDifficulty: 500,
    normalDifficulty: 1000,
    hardDifficulty: 1500,
  },
  audio: {
    baseVolume: 100,
    clickPerSecond: 500,
    clickDuration: 1000,
    minClickDuration: 500,
    maxClickDuration: 1500,
    ZoomerCases: {
      off: 0,
      interval_5_seconds: 5,
      interval_10_seconds: 10,
    },
  },
  calculation: {
    timeBetweenCalculations: 2000,
    timeOffsetCalculations: 0,
    easiestCalculationDuration: 7000,
    hardestCalculationDuration: 2000,
    positionDividerY: 3,
    setOrigin: 0.5,
    calculationTextEN: 'Calculation task',
    calculationTextNL: 'Rekentaak',
    calculationTextDE: 'Rechenaufgabe',
    calculationDefaultColor: '#FFFFFF',
    calculationChildColor: '#494A4E',
  },
  movingTarget: {
    easiestSpeedModifier: 0.0875,
    hardestSpeedModifier: 17.5,
    defaultSpeedModifier: 8.75,
    imageX: 300,
    imageY: 300,
    timeForBottomLeftToTopRightAtDefaultSpeedInMilliseconds: 650,
    ellipseTurnAroundRadiusX: 80,
    ellipseTurnAroundRadiusY: 40,
    ellipseTurnAroundDevider: 3,
    baseSpeed: 444,
    speedModifier: 10,
    ellipseSpeedMultiplier: 4.75,
    bouncingSpeedMultiplier: 4.75,
    horizontalSpeedMultiplier: 2,
    fadeout: 1000,
    trajectoryTransition: 1000,
    ellipseRadiusX: 0.4,
    ellipseRadiusY: 0.35,
    colourRateUpdate: 2000,
    linearMaxLeft: 10 / 100,
    linearMaxRight: 90 / 100,
    snapOutTop: 20 / 100,
    snapOutBottom: 80 / 100,
    pixelsPerSecond: 500,
    circleRadius: 820,
    horizontalEightRadius: 0.17,
    horizontalEightHeightScale: 0.95,
    bouncingPointOnCircle: 0.5 + 0.25,
    bouncingMultiplier: 1000,
    horizontalEightRadiusRotation: 180,
    heightPercent: 0.6,
  },
  reaction: {
    timeBetweenAuditoryReaction: 2000,
    timeToDecreaseAuditoryReaction: 0,
    easiestAuditoryDuration: 6000,
    hardestAuditoryDuration: 3000,
    timeBetweenVisualReaction: 2000,
    shortenTimeBetweenAuditoryReaction: 100,
    timeToDecreaseVisualReaction: 0,
    easiestVisualDuration: 7000,
    hardestVisualDuration: 2000,
    timeBetweenAnimation: 2000,
    timeOffsetAnimation: 0,
    easiestAnimationDuration: 7000,
    hardestAnimationDuration: 2000,
    visualReactionSizeX: 60,
    visualReactionSizeY: 60,
    spriteScaleSize: 0.7,
    spriteFixPositionX: 0.12,
    spriteFixPositionY: 0.9,
    childSpriteFixPositionY: 0.9,
  },
  stroop: {
    setOrigin: 0.5,
    addPositionY: 80,
    invisibleDuration: 500,
    timeBetweenStroopReaction: 2000,
    timeToDecreaseStroopReaction: 0,
    easiestStroopDuration: 7000,
    hardestStroopDuration: 2000,
    coloursEnglish: ['RED', 'BLUE', 'PURPLE', 'YELLOW', 'ORANGE', 'GREEN'],
    coloursDutch: ['ROOD', 'BLAUW', 'PAARS', 'GEEL', 'ORANJE', 'GROEN'],
    coloursGerman: ['ROT', 'BLAU', 'lILA', 'GELB', 'ORANGE', 'GRÜN'],
    coloursUkrainian: ['ЧЕРВОНИЙ', 'СИНІЙ', 'ФІОЛЕТОВИЙ', 'ЖОВТИЙ', 'ПОМАРАНЧОВИЙ', 'ЗЕЛЕНИЙ'],
    coloursCode: ['#B22222', '#1E90FF', '#9370DB', '#FFFF00', '#FFA500', '#90EE90'],
  },
};
